import _ from 'lodash';
import appHelpers from 'app/app-helpers';
import loginHelpers from 'auth/helpers/login';
import { checkAccess } from 'app/actions/app.actions';
import { fetchNewLabelStatus } from 'documents/actions/fetch-new-label-status.actions';
import * as api from 'app/resources/login-popup.api';
import formTemplate from './views/login-form.html';
import formMobileTemplate from './views/login-form-mobile.html';
import termsOfUseTpl from './views/login-terms-of-use.html';

const mapStateToThis = ({ session, config }) => {
  const { jurisdictionId } = config;

  return {
    jurisdictionId,
    session,
  };
};

const mapDispatchToThis = {
  checkAccess,
  fetchNewLabelStatus,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications', '$sce', '$localStorage')
class LoginFormController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.signUp = this.checkAccess('auth.signUp');
    this.forgotUsername = this.checkAccess('auth.forgotUsername');
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async loginHandler(form, acceptTerms = false, tokens) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    try {
      const registrationForm = false;
      await this.api.login.run(this.model.credentials, acceptTerms, registrationForm, tokens);
    } catch (error) {
      const errorCode = _.get(error, 'data.errors[0].code') || '';
      (_.get(loginHelpers, `handle${errorCode}`) || loginHelpers.handleDefault)(this, form, error);
      return;
    }

    if (this.isPasswordExpired()) {
      this.redirectToPasswordReset();
      return;
    }
    await this.showPopupInfo();
    await this.showNewLabel();
    this.redirectAfterLogin();
  }

  isPasswordExpired() {
    const { tokens } = this.session;
    return tokens.jwt.passwordExpired === 'true';
  }

  redirectToPasswordReset() {
    return appHelpers.redirectToPasswordReset({
      $state: this.$state,
      Notifications: this.Notifications,
      gettextCatalog: this.gettextCatalog,
    });
  }

  redirectAfterLogin() {
    return appHelpers.redirectAfterLogin(
      {
        $state: this.$state,
        Notifications: this.Notifications,
        gettextCatalog: this.gettextCatalog,
        config: this.api.config,
        $ngRedux: this.$ngRedux,
      },
      this.model,
      this.session.attemptedRoute
    );
  }

  async showNewLabel() {
    const hasAccessToDocumentsView = this.checkAccess('documents.view');
    if (hasAccessToDocumentsView) await this.fetchNewLabelStatus();
  }

  async showPopupInfo() {
    const message = await api.fetchPopupOnLogin(this.jurisdictionId, this.session);
    const ommitPopupInfo = this.session.passwordReset || this.session.temporaryUser || this.session.isAdmin;
    if (!ommitPopupInfo && message) {
      const hashMessage = `${this.session.id}-${this.hashCode(message)}`;
      if (!this.$localStorage[hashMessage]) {
        this.$localStorage[hashMessage] = true;
        return this.Notifications.showAlert('', message, { backdrop: 'static' }).result;
      }
    }
    return Promise.resolve();
  }

  hashCode(s) {
    return s.split('').reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0);
  }

  showTermsOfUse() {
    this.Notifications.showComplexDialog({
      template: termsOfUseTpl,
      resolve: {
        config: () => this.config,
        $sce: () => this.$sce,
        model: () => this.model,
        api: () => this.api,
      },
    });
  }
}

class LoginFormComponent {
  constructor() {
    this.controller = LoginFormController;
    this.template = formTemplate;
    this.bindings = {
      model: '<',
      api: '<',
      forgotUsername: '<',
      config: '<',
    };
    return this;
  }
}

class LoginFormMobileComponent {
  constructor() {
    this.controller = LoginFormController;
    this.template = formMobileTemplate;
    this.bindings = {
      model: '<',
      api: '<',
      forgotUsername: '<',
    };
    return this;
  }
}

angular
  .module('login-form', [])
  .component('loginForm', new LoginFormComponent())
  .component('loginFormMobile', new LoginFormMobileComponent());



// WEBPACK FOOTER //
// ./src/modules/auth/components/login-form/login-form-component.js